module.exports = __webpack_public_path__ + "static/media/logo-bagy.2505c8f6.svg";